import { SettingOutlined } from '@ant-design/icons';
import React from 'react';

import ConfirmButton from './ConfirmButton';

const ModifyButton = ({ loading, modify, onCancel }) => {
  return <ConfirmButton loading={loading} type={'dashed'} shape={'circle'} icon={<SettingOutlined />} onClick={modify} onCancel={onCancel} />;
};
export default ModifyButton;
